/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUserTypingRequest} from '@cash-web/protos/squareup/cash/supportal/service.pb'
import {GetUserTypingResponse} from '@cash-web/protos/squareup/cash/supportal/service.pb'


export const getUserTyping = (request:GetUserTypingRequest, options?: CashRequestOptions) => post<GetUserTypingRequest, GetUserTypingResponse>("/2.0/cash/get-user-typing", request, {...options, rejectOnError: true })